export const AdminSelectors = {
    Cpties: (state) => state.Admin.cpties,
    SelectedCpty: (state) => state.Admin.selectedCpty,
    Loading: (state) => state.Admin.loading,
    Error: (state) => state.Admin.error,
    FeatureFlags: (state) => state.Admin.featureFlags,
    FlagsLoading: (state) => state.Admin.flagsLoading,
    FlagsError: (state) => state.Admin.flagsError,
    Users: (state) => state.Admin.users,
    UsersLoading: (state) => state.Admin.usersLoading,
    UsersError: (state) => state.Admin.usersError,
};
